import * as React from "react";
import clsx from "clsx";
import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, MenuItem } from "../../../DropdownMenu";
import { useT } from "../../../../../app/lib/i18n";
import * as s from "./ContextButton.style.css";
import type { ContextButtonProps } from "./ContextButton.types";

export { type ContextButtonAction } from "./ContextButton.types";

export function ContextButton({
  actions,
  disabled = false,
  ariaLabel,
}: ContextButtonProps) {
  const t = useT();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef<HTMLButtonElement>(null);

  if (actions.length === 0) return null;

  const handleChange = (actionId: string) => {
    actions.find((a) => a.id === actionId)?.onSelect();
  };

  return (
    <>
      <button
        ref={anchorRef}
        type="button"
        className={s.iconButton}
        disabled={disabled}
        aria-label={ariaLabel ?? t("shared.ui.moreActions")}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prev) => !prev);
        }}
      >
        <MoreHorizontal size={14} />
      </button>
      <DropdownMenu
        anchorEl={anchorRef}
        anchorPos="SE"
        openDirection="SW"
        open={open}
        setOpen={setOpen}
        onChange={handleChange}
        closeOnSelect
      >
        {actions.map((action) => (
          <MenuItem key={action.id} value={action.id} disabled={action.disabled} title={action.disabledTooltip}>
            <span className={clsx(s.menuItemContent, action.destructive && s.menuItemDanger)}>
              {action.icon && <span className={s.menuItemIcon}>{action.icon}</span>}
              {action.label}
            </span>
          </MenuItem>
        ))}
      </DropdownMenu>
    </>
  );
}
